import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box
} from "@material-ui/core";
import { MONTHS, YEAR_RANGE, YEARS_BACK_FROM_CURRENT } from './constants';

const DatePickerDialog = ({
  open,
  onClose,
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
  onConfirm,
  classes
}) => {
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: YEAR_RANGE }, 
    (_, i) => currentYear - YEARS_BACK_FROM_CURRENT + i
  );

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        className: classes.dialogPaper
      }}
    >
      <DialogTitle className={classes.dialogTitle}>
        Добавить отчетный период
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box display="flex" flexDirection="column" gap={2} minWidth={320}>
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel>Год</InputLabel>
            <Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {yearOptions.map(year => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel>Месяц</InputLabel>
            <Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {MONTHS.map(month => (
                <MenuItem key={month.value} value={month.value}>
                  {month.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button 
          onClick={onClose} 
          className="cancel-button"
        >
          Отмена
        </Button>
        <Button 
          onClick={onConfirm}
        >
          Добавить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DatePickerDialog;